// Pre-Rendering für Google (Prerender.io-Konvention): window.prerenderReady erst true, wenn keine API-Anfrage mehr läuft
// und die Seite 700 ms „ruhig“ war – so wird nie ein Lade-Skelett (ohne Titel/JSON-LD) als Snapshot gespeichert.
let inflight = 0, timer = null;
const arm = () => {
  clearTimeout(timer);
  if (inflight === 0) timer = setTimeout(() => { if (inflight === 0) window.prerenderReady = true; }, 700);
};
export const reqStart = () => { inflight++; clearTimeout(timer); window.prerenderReady = false; };
export const reqEnd = () => { inflight = Math.max(0, inflight - 1); arm(); };
export const track = (promise) => { reqStart(); return promise.finally(reqEnd); };
export const resetPrerenderReady = () => { window.prerenderReady = false; arm(); };
